















import { Component, Mixins, Prop } from 'vue-property-decorator';
import { Actions, Mutations } from '@/ts/store/Constants';
import TicketHelper from '@/mixins/TicketHelper.vue';

@Component
export default class TicketPriorityDropdown extends  Mixins(TicketHelper) {
    @Prop() public ticket: any;

    public changeTicketPriority(priorityId: number) {
        this.ticket.priority = priorityId;
        this.$store.dispatch(Actions.CHANGE_TICKET_PRIORITY, {ticketId: this.ticket.id, priorityId});
        this.$store.commit(Mutations.TICKET_PRIORITY_DROPDOWN_VISIBILITY, false);
    }
}
